import { Partial } from '@40seas/entities/common';
import { CreateTransactionDto } from './create.transaction.dto';

export class UpdateTransactionDto extends Partial(CreateTransactionDto) {}
